'use client';

import React from 'react';
import { MapPin } from 'lucide-react';

interface LocationPreviewProps {
  latitude: number;
  longitude: number;
  address?: string;
  placeName?: string;
  staticMapUrl?: string;
  isOwnMessage?: boolean;
}

export const LocationPreview: React.FC<LocationPreviewProps> = ({
  latitude,
  longitude,
  address,
  placeName,
  staticMapUrl,
  isOwnMessage = false,
}) => {
  const handleOpenMaps = () => {
    const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(googleMapsUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      onClick={handleOpenMaps}
      className="w-full max-w-[200px] rounded-lg overflow-hidden cursor-pointer hover:opacity-90 transition-opacity"
    >
      {/* Map Preview Image */}
      {staticMapUrl ? (
        <img
          src={staticMapUrl}
          alt="Location"
          className="w-full h-[100px] object-cover"
        />
      ) : (
        <div className="w-full h-[100px] bg-gray-200 flex items-center justify-center">
          <MapPin className="w-6 h-6 text-gray-400" />
        </div>
      )}

      {/* Location details at bottom */}
      <div className="px-2 py-1.5">
        <p className={`text-[11px] font-medium truncate ${isOwnMessage ? 'text-primary-foreground' : 'text-foreground'}`}>
          {placeName || 'Shared Location'}
        </p>
        {address && (
          <p className={`text-[10px] truncate mt-0.5 ${isOwnMessage ? 'text-primary-foreground/70' : 'text-muted-foreground'}`}>
            {address}
          </p>
        )}
      </div>
    </div>
  );
};

export default LocationPreview;
